<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-autocomplete variant="underlined" :items="$model.modules.kcp.model.clients" v-model="selectedOrg"
            label="Организация" item-title="name" item-value="ogrn" :disabled="$model.modules.kcp.model.isDir || !$model.modules.kcp.model.isMinObrHost">
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="auto">
          <v-select v-model="selectedYear" :items="yearsList" item-title="year" return-object variant="underlined"
            label="Год" hide-details></v-select>
        </v-col>
        <v-col align-self="end">
          <!-- министерство -->

          <v-dialog v-model="addStepDialog" persistent width="400" v-if="$model.modules.kcp.model.isMinObr">
            <template v-slot:activator="{ props }">
              <v-chip v-bind="props" style="cursor: pointer" @click="editingStep = newStep">
                <span>Добавить этап</span>
              </v-chip>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5" v-if="editingStep && editingStep.start == ''">Добавить этап</span>
                <span class="text-h5" v-else>Редактировать этап</span>
              </v-card-title>
              <v-form ref="editStep" @submit.prevent v-model="isFormValid">
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field v-model="editingStep.name" label="Название" required></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field v-model="editingStep.numSeats"
                          label="Количество мест, доступных для распределения" required></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-text-field :rules="isDate" v-model="editingStep.start" label="Начало этапа*" type="date"
                          required></v-text-field>
                      </v-col>
                      <v-col>
                        <v-text-field v-model="editingStep.stop" label="Этап будет завершен" type="date"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-switch v-model="editingStep.active" label="Активный" color="primary"></v-switch>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="addStepDialog = false">
                    Отмена
                  </v-btn>
                  <v-btn color="blue-darken-1" variant="text" type="submit" @click="addStep">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>

    <div class="mt-5" v-if="selectedYear">
      <v-menu v-model="step.rightMenu" v-for="(step, t) in selectedYear.data.steps" :key="t">
        <template v-slot:activator="{ props }">
          <v-chip :class="t == selectedStage ? 'ma-2' : 'ma-2 selectedStep'"
            :color="step.active == true ? 'success' : 'pink'" :variant="t == selectedStage ? 'outlined' : 'elevated'"
            v-bind="props" @click.left.prevent="step.rightMenu = false" @click.right.prevent="step.rightMenu = true"
            @click="t == selectedStage ? null : loadData(step, t)">
            {{ step.name }}
            <v-tooltip activator="parent" location="top">
              <span v-if="step.active">{{ step.start }} / {{ step.stop }}<br />действует</span>
              <span v-else>{{ step.start }} / {{ step.stop }}<br />завершен</span>
              <br />
              <span>распределяется {{ step.numSeats }} мест</span>
            </v-tooltip>
          </v-chip>
        </template>
        <v-list v-if="$model.modules.kcp.model.isMinObr">
          <v-list-item>
            <v-list-item-title>
              <v-list-item-title class="pointer" @click="
                editingStep = step;
              editingStep.stage = t;
              addStepDialog = true;
              ">Редактировать</v-list-item-title>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <br /><br />
    <v-btn v-if="!$model.modules.kcp.model.isMinObr && sendDataButtonActive" color="primary" append-icon="mdi-upload" @click="sendData()">
      Отправить данные
    </v-btn>
    <v-btn v-if="$model.modules.kcp.model.isMinObr" color="success" append-icon="mdi-microsoft-excel" @click="print()">
      Печать
    </v-btn>

    <v-tabs v-model="tab" align-with-title>
      <v-tab v-for="(name, indicator) in indicators" :key="indicator">
        {{ name }}
      </v-tab>
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item v-for="(name, indicator) in indicators" :key="indicator">
        <data-table v-if="
          (selectedStage != null && indicator == 'kcp') ||
          indicator == 'kcpOrganization' ||
          indicator == 'kcpSpecialty'
        " :ogrn="selectedOrg" :year="selectedYear.year" :step="selectedStage" :indicator="indicator" :editable="sendDataButtonActive"
          :isMinObrHost="$model.isMinObrHost" :isDirector="this.$model.isDir"></data-table>
        <span v-else>не выбран этап</span>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>
    <v-overlay v-model="overlay"></v-overlay>
  </div>
</template>

<script>
import dataTable from "./data.vue";
export default {
  components: {
    "data-table": dataTable,
  },
  data() {
    return {
      indicators: {
        kcpOrganization: "Показатели организации в целом",
        kcpSpecialty: "Показатели деятельности специальности",
        kcp: "КЦП",
      },
      selectedOrg: false,
      isFormValid: false,
      isDate: [
        (value) => {
          return (
            (value !== null && !isNaN(new Date(value))) || "Некорректная дата"
          );
        },
      ],
      editingStep: null,
      newStep: {
        numSeats: 0,
        name: "",
        start: "",
        stop: "",
        active: false,
      },
      addStepDialog: false,
      tab: null,
      overlay: false,
      selectedStage: null,
      yearsList: [],
      selectedYear: null,
      sendDataButtonActive:true
    };
  },
  created() {
    console.log(this.$model.modules.kcp.model)

    this.$model.modules.kcp.model.clients=Object.values(this.$model.modules.kcp.model.clients);
    this.reloadYears(this.$model.modules.kcp.model.config.years);
    this.selectedOrg = this.$model.modules.kcp.model.clients[0].name;
  },
  methods: {
    reloadYears(years) {
      this.yearsList = years;
      this.selectedYear = years[0];
      if(this.selectedYear.data.steps != undefined && this.selectedYear.data.steps.length){
        this.sendDataButtonActive=this.selectedYear.data.steps[this.selectedYear.data.steps.length-1].active;
      }
      years.forEach((year) => {
        if (year.data.steps != undefined) {
          year.data.steps.forEach((step) => {
            step.rightMenu = false;
          });
        }
      });
    },
    addStep() {
      if (!this.isFormValid) {
        return;
      }
      this.addStepDialog = false;
      //-----------------------------------------
      let newStep = { ...this.editingStep };
      delete newStep.rightMenu;

      let params = {
        year: this.selectedYear.year,
        step: JSON.stringify(newStep),
      };
      //-------------------------------------------

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/kcp/addStep",
          new URLSearchParams(params),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.$model.modules.kcp.model.config.years = resp.data;
          this.reloadYears(this.$model.modules.kcp.model.config.years);
        })
        .catch((reject) => {
          if (
            reject.response != undefined &&
            reject.response.data != undefined
          ) {
            let m = reject.response.data;
            try {
              JSON.parse(m);
            } catch (e) { }
            m = m instanceof String || typeof m === "string" ? m : m.message;
            console.log(m);
            this.$eventBus.$emit("show-dialog", {
              title: "Ошибка",
              content: m,
            });
          }
        });
    },
    sendData() {
      let params = {
        year: this.selectedYear.year,
        ogrn: this.selectedOrg,
      };
      this.overlay = true;

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/kcp/sendData",
          new URLSearchParams(params),
          {
            headers: {
              Accept: "application/json",
              "Content-type":
                "application/x-www-form-urlencoded; charset=UTF-8",
            },
          }
        )
        .then((resp) => {
          this.$eventBus.$emit("show-dialog", {
              title: "Успешно",
              content: "Отправлено успешно",
            });
          this.overlay = false;
        })
        .catch((reject) => {
          this.overlay = false;
        });
    },
    print() {
      let params = {
        year: this.selectedYear.year,
      };
      this.overlay = true;

      this.axios
        .post(
          this.$model.wwwroot + "/procollege/report/minobr/kcp/printKCPContest",
          new URLSearchParams(params),
          { 
            responseType: 'blob' 
          }
        )
        .then((resp) => {
          this.overlay = false;
          let filename = "kcpcontest.xlsx";

          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(resp.data);
          link.download = filename;

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
        })
        .catch((reject) => {
          this.overlay = false;
        });
    },
    loadData(step, stage) {
      //console.log(step.rightMenu);
      //step.rightMenu = false;
      this.selectedStage = stage;
    },
    loadDataFromDB() { },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}

.pointer:hover {
  background-color: lightgrey;
}

:deep(div.v-chip__content) {
  font-size: 0.875rem !important;
}

.selectedStep {
  box-shadow: 3px 3px 5px 0px rgba(66, 68, 90, 1);
}
</style>
